import type { SportsHit } from "components/layout/Search/Results/models";
import { useTitles } from "hooks/graphql/useTitles";
import { TitleIcon } from "components/TitleIcon";
import React from "react";
import { Row } from "./Row";
import { ResultsInIndex } from "./ResultsInIndex";
import { Highlight } from "./Highlight";
import { useNormalisedHits } from "components/layout/Search/Results/hooks/useNormalisedHits";

export const SportsResults = () => {
  const { items, results } = useNormalisedHits<SportsHit>();
  const titles = useTitles();
  return (
    <ResultsInIndex
      indexName={`Sports`}
      total={results?.nbHits || 0}
      pages={results?.nbPages || 0}
      perPage={results?.hitsPerPage || 0}
    >
      {(items || []).map((item) => {
        const sportHighlight = item.normalisedHighlights?.sport?.[0];
        return (
          <Row
            key={item.objectID}
            icon={<TitleIcon title={titles[item.slug]} svg />}
            title={
              <Highlight
                text={item.sport}
                matchedWords={sportHighlight?.matchedWords || []}
                html={sportHighlight?.value || ""}
              />
            }
            to={`${
              item.hub === "sports"
                ? "/sports"
                : item.hub === "racing"
                  ? "/racing"
                  : ""
            }/${item.slug}/betting`}
          />
        );
      })}
    </ResultsInIndex>
  );
};
